import * as React from 'react';
import styled from 'styled-components';
import { Close } from '../../icons';
import { Button } from './CommonStyles';

const StyledButton = styled(Button)`
  padding: 0;
  height: 36px;
`;

type Props = {
  closeMenu: () => void;
};

const ExitMenuButton = ({ closeMenu }: Props): React.ReactElement<Props> => {
  return (
    <StyledButton onClick={closeMenu}>
      <Close size="24px" />
    </StyledButton>
  );
};

export default ExitMenuButton;
